'use strict';

module.exports = require('react/lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** /jobvolume/donatenodeweb-ci-9488/workspace/Release/~/react-dom/index.js
 ** module id = 32
 ** module chunks = 0 1 2 3 4 5 6
 **/